module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal form-grv"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                    Apreensão\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Pré-retirada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("810000359 - Wallace Alonso Da Silva")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Dados da Cobrança\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Descricao")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Diárias e Reboque para GRV 140140011")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("20/05/2019")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Normal")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Baixa\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    staticClass: "form-control"
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Não Pago")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pago")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Cancelado Pago")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("2762,71")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Desconto")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "",
      "name": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Valor pago")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("R$ 2762.71")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Falta pagar")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("R$ 0.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Tipo cobrancas\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Referência")]), _vm._v(" "), _c('th', [_vm._v("Opções")]), _vm._v(" "), _c('th', [_vm._v("Cancelada")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Boleto")]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control"
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Boleto")])])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "",
      "name": ""
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "",
      "name": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-info btn-md m-l-xs"
  }, [_vm._v("Consultar")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    }
  }), _c('i')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar e continuar editando")])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1971cdd9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/preretirada/components/Cobranca.vue
// module id = 1530
// module chunks = 17